import store from "../../../../../stateManagement/store";
import { createFilters, createOptionsWithLabel, removeDuplicates } from "../../../services/services";
import { currentMustBuyType, schemeProductBifurcationsListItemType } from "../../../types";
import { INVALID, INVALID_EMPTY_DATA, VALID } from "../../../utils/utils";
import { generateFilters, getBatchCodeFromBatchCodeSkuDescriptionString, getFilteredProducts, getProducts, getValueFromValueConcatenatedLabel, overlappingBatchCodes } from "../productSelection/service";

/**
 * this function will return the content/ options for the current selected tabs for must buy
 * @param currentSelectedValues 
 * @param entityName 
 * @returns 
 */
export async function getMustBuyTabContent(currentSelectedValues: Record<string,string[] | null>, entityName: string) {
    const { ALL_PRODUCTS } = store.getState().manageCoupons?.configData;
    // we only show those options in must buy which are selected in product selection
    const { schemeProductBifurcationsList } = store.getState().manageCoupons?.data;
    let productsData:any[] = getProductsForMustBuy(schemeProductBifurcationsList,ALL_PRODUCTS,entityName);
    // generate filters from our current selected values
    const filters = await generateFilters(currentSelectedValues,entityName);
    
    if (filters.length === 0) {
         const finalList = createOptionsWithLabel(entityName,productsData);
        return removeDuplicates(finalList);
    }

    const products = getFilteredProducts(filters, entityName,productsData);
    const finalList = createOptionsWithLabel(entityName,products)
    return removeDuplicates(finalList);
}

function getProductsForMustBuy(schemeProductBifurcationsList: Array<schemeProductBifurcationsListItemType>,products:any[] , entityName:string){
    let finalSelection: string[] = [];

    for (let i = 0; i < schemeProductBifurcationsList.length; i++) {
        const data = schemeProductBifurcationsList[i][entityName];
        // length zero means ALL is selected
        if (data.length === 0) return products;
        else if(Array.isArray(data)) finalSelection=[...finalSelection , ...data.map((item:string)=>getValueFromValueConcatenatedLabel(item,entityName))]
    }

    return products.filter((item)=>finalSelection.includes(item[entityName]));
}


/**
 * this function will get all the products that have the particular brand
 * @param schemeProductBifurcationsList 
 * @param products 
 * @returns 
 */
// function getProductWithItemClassForMustBuy(schemeProductBifurcationsList: Array<schemeProductBifurcationsListItemType>,products:any[]) {
//     let finalItemClass: string[] = [];

//     for (let i = 0; i < schemeProductBifurcationsList.length; i++) {
//         const itemClass = schemeProductBifurcationsList[i].itemClass;
//         // length zero means ALL is selected
//         if (itemClass.length === 0) return products;
//         else if(Array.isArray(itemClass)) finalItemClass = [...finalItemClass, ...itemClass];
//     }

//     return products.filter((item)=>finalItemClass.includes(item.itemClass));
// }


/**
 * this function will get all the products that have the particular brand
 * @param schemeProductBifurcationsList 
 * @param products 
 * @returns 
 */
// function getProductWithBrandsForMustBuy(schemeProductBifurcationsList: Array<schemeProductBifurcationsListItemType>,products:any[]) {
//     let finalBrands: string[] = [];
//     for (let i = 0; i < schemeProductBifurcationsList.length; i++) {
//         const brands = schemeProductBifurcationsList[i].brand;
//         // length zero means ALL is selected
//         if (brands.length === 0) return products;
//         else if(Array.isArray(brands)) finalBrands = [...finalBrands, ...brands];
//     }

//     return products.filter((item)=>finalBrands.includes(item.brand));
// }





/**
 * this function will get all the products that have our selected flavour
 * @param schemeProductBifurcationsList 
 * @param products 
 * @returns 
 */
// function getProductWithFlavoursForMustBuy(schemeProductBifurcationsList: Array<schemeProductBifurcationsListItemType>,products:any[]) {
//     let finalFlavours: string[] = [];

//     for (let i = 0; i < schemeProductBifurcationsList.length; i++) {
//         const flavours = schemeProductBifurcationsList[i].flavour;
//         // length zero means ALL is selected
//         if (flavours.length === 0) return products;
//         else if(Array.isArray(flavours)) finalFlavours = [...finalFlavours, ...flavours];
//     }

//     return products.filter((item)=>finalFlavours.includes(item.flavour));
// }


/**
 * this function will get all the products that have our selected peice size
 * @param schemeProductBifurcationsList 
 * @param products 
 * @returns 
 */

// function getProductWithPeiceSizeForMustBuy(schemeProductBifurcationsList: Array<schemeProductBifurcationsListItemType>,products:any[]) {
//     let finalPeiceSize: string[] = [];

//     for (let i = 0; i < schemeProductBifurcationsList.length; i++) {
//         const pieceSize = schemeProductBifurcationsList[i].pieceSize;
//         // length zero means ALL is selected
//         if (pieceSize.length === 0) return products;
//         else if(Array.isArray(pieceSize)) finalPeiceSize = [...finalPeiceSize, ...pieceSize];
//     }
//     return products.filter((item)=>finalPeiceSize.includes(item.pieceSize));
// }


/**
 * this function will get all the products that have our selected batchCodes
 * @param schemeProductBifurcationsList 
 * @param products 
 * @returns 
 */

function getProductWithBatchCodeForMustBuy(schemeProductBifurcationsList: Array<schemeProductBifurcationsListItemType>,products:any[]) {
    let finalBatchCodes: string[] = [];
    for (let i = 0; i < schemeProductBifurcationsList.length; i++) {
        const batchCodeCodes = schemeProductBifurcationsList[i].batchCode;
        // length zero means ALL is selected
        if (batchCodeCodes.length === 0) return products;
        else if(Array.isArray(batchCodeCodes)) finalBatchCodes = [...finalBatchCodes, ...batchCodeCodes.map((code:string)=>getBatchCodeFromBatchCodeSkuDescriptionString(code))];
    }    
    return products.filter((item)=>finalBatchCodes.includes(item.batchCode));
}


/**
 * performs all the validations for must buy
 * @param currentData 
 * @param tabsList 
 * @returns 
 */
export function validateMustBuy(currentData:currentMustBuyType,tabsList:string[]):string{
    // checking for empty data
    const res1 = emptyDataMustBuyValidation(currentData,tabsList);
    if(res1!==VALID) return res1;

    // checking for overlapping 
    const res2 = overlappingBatchCodesMustBuyValidation(currentData,tabsList);
    if(res2!==VALID) return res2;

    const res3 = outOfProductSelectionValidation(currentData , tabsList);
    if(res3!==VALID) return res3;

    return VALID;
}

/**
 * checks if the the data send is empty or not;
 * @param currentData 
 * @param tabsList 
 * @returns 
 */
export const emptyDataMustBuyValidation = (currentData:currentMustBuyType,tabsList:string[])=>{
    if(!currentData) return INVALID_EMPTY_DATA;
    let allEmpty = true;
    for(let i=0 ; i<tabsList.length ; i++){
        const currentTab = tabsList[i];
        if(currentData && currentData[currentTab] && currentData[currentTab]?.length > 0) allEmpty = false;
    }
    if(allEmpty) return INVALID_EMPTY_DATA;
    return VALID;
}


/**
 * Checks if already present must buy is overlapping with current data
 * this is done by getting batchCodes under the already Present must buy list and checking if any
 * getting batchCodes under current selection and if there are overlaps of batchCodes 
 * the validation fails
 * @param currentData 
 * @param tabsList 
 * @returns 
 */
const overlappingBatchCodesMustBuyValidation = (currentData:currentMustBuyType,tabsList:string[])=>{
    // check overlapping at batchCode level 
     const {data: mustBuy} = store.getState()?.manageCoupons?.data?.mustBuy;
    return overlappingBatchCodes(currentData , tabsList , mustBuy);
}

/**
 * checks if the current data is out of range of our product selection
 * @param currentData current selection
 * @param tabsList helps to get only entities data from currentData
 * @returns 
 */
const outOfProductSelectionValidation = (currentData: currentMustBuyType, tabsList: string[]) => {
    // checking if selected must buy is a subset of the product selection (BatchCode Level Wise)

    const { schemeProductBifurcationsList } = store.getState()?.manageCoupons?.data;
    const { ALL_PRODUCTS } = store.getState()?.manageCoupons?.configData;

    const filters: Record<string, string[]> = createFilters(currentData , tabsList);
    const filteredProducts = getProducts(ALL_PRODUCTS, filters); // these are all products that passes the selection criteria of user 
    const filteredProductsBatchCode = filteredProducts.map((item) => item.batchCode);
    let schemeProductBifurcationsListBatchCodes: string[] = [];

    for (let i = 0; i < schemeProductBifurcationsList.length; i++) {
        const curr = schemeProductBifurcationsList[i];
        const filter = createFilters(curr , tabsList);
        const currSkuProducts = getProducts(ALL_PRODUCTS,filter).map((item) => item.batchCode);
        schemeProductBifurcationsListBatchCodes = [...schemeProductBifurcationsListBatchCodes, ...currSkuProducts];

    }

    if(schemeProductBifurcationsListBatchCodes.length ===0) return VALID; // it means ALL batchCodes are selected 
    // filteredProductsBatchCode should be a subset of products selected in product selection
    for (let i = 0; i < filteredProductsBatchCode.length; i++) {
        const currBatchCode = filteredProductsBatchCode[i];
        if (!schemeProductBifurcationsListBatchCodes.includes(currBatchCode)) {
            return INVALID;
        }
    }

    return VALID;
}

/**
 * Checks whether all the must buy have their min quantity filled 
 * @returns 
 */

export const mustBuyAllminQtyFilled = ():boolean=>{
    const { data:mustBuy } = store.getState()?.manageCoupons?.data?.mustBuy;
    for(let i=0 ; i<mustBuy.length ; i++){
        if(mustBuy[i]["min_qty"] === null || mustBuy[i]["min_qty"] === undefined || mustBuy[i]["min_qty"] === "") return false;
    }
    return true;
}



/**
 * checks whether all the must buy created have min quantity value greater than zero
 * @returns 
 */

export const mustBuyAllminQtyGreaterThanZero = ():boolean=>{
    const { data:mustBuy } = store.getState()?.manageCoupons?.data?.mustBuy;
    for(let i=0 ; i<mustBuy.length ; i++){
        if(Number(mustBuy[i].min_qty) < 0) return false;
    }
    return true;
}

/**
 * return whether must buy is empty or not
 * @returns boolean
 */

export const isMustBuyEmpty=():boolean=>{
    const { data:mustBuy } = store.getState()?.manageCoupons?.data?.mustBuy;
    return mustBuy.length ===0;
}